//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TopNavService } from "@nuskin/ns-product";
import { NsTabs, NsTab, NsTabsItems } from "@nuskin/design-components";

import NsTopnavSection from "./NsTopnavSection.vue";

export default {
  name: "NsTopnav",
  components: {
    NsTabs,
    NsTab,
    NsTabsItems,
    NsTopnavSection
  },
  data: function() {
    return {
      /**
       * Toggles display of the corresponding mega dropdown section
       * -1 unsets display
       */
      navSelected: -1,
      navigation: []
    };
  },
  watch: {
    navSelected: {
      immediate: true,
      handler() {
        document
          .querySelectorAll(".tabItem.iron-selected .tab-column__body")
          // eslint-disable-next-line arrow-parens
          .forEach(column => {
            column.style.width = `${column.scrollWidth}px`;
          });
      }
    }
  },
  mounted: function() {
    this.getNavigation();
  },
  methods: {
    deselectTab() {
      this.navSelected = -1;
    },
    selectTab(index) {
      this.navSelected = index;
    },
    async getNavigation() {
      this.navigation = await TopNavService.getNextGenAndCsTopNavigation();
    }
  }
};
